// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    productContext?: ProductContextModel;
    modalIsOpen: boolean;
    skipModal?: boolean;
}

type HandlerType = Handler<Parameter>;

export const DispatchCompleteSetRequestQuoteModalData: HandlerType = props => {
    props.dispatch({
        type: "RequestQuoteModal/CompleteSetIsOpen",
        isOpen: props.parameter.modalIsOpen,
        productContext: props.parameter.productContext,
    } as any);
    
    if (props.parameter.skipModal !== undefined) {
        window.localStorage.setItem("skip-request-quote-modal", `${props.parameter.skipModal}`);
    }
};

export const chain = [DispatchCompleteSetRequestQuoteModalData];

const setRequestQuoteModal = createHandlerChainRunner(chain, "setRequestQuoteModal");
export default setRequestQuoteModal;
